import localStorage from "redux-persist/lib/storage";

// Configuración de persistencia: persistimos solo el slice de autenticación
export const persistConfig = {
  key: "root",
  storage: localStorage,
  whitelist: ["auth"],
};
